import axios from 'axios';
import { createLogger } from '../../config/logger';

const logger = createLogger('axios_api');

// API base URL from environment variable, with fallback for development
export const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v1',
});

// Token getter will be set by store configuration
let getToken = null;

/**
 * Sets the token getter function for the API client
 * This replaces the global store injection pattern
 * @param {Function} tokenGetter - Function that returns the current access token
 */
export const setTokenGetter = (tokenGetter) => {
    getToken = tokenGetter;
};

// Inject Supabase access token into every request
// Backend handles authentication at route level - public endpoints will ignore the token
api.interceptors.request.use(async (config) => {
    try {
        const token = getToken ? getToken() : null;
        
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            // No token available - backend will handle public endpoints appropriately
            logger.debug('No access token available, request may be to public endpoint');
        }
    } catch (err) {
        logger.error('Error getting access token', err);
    }

    return config;
});
